export class Data {
  id?: number;
  name?: string;
  value?: string;
}
